import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { IMAGES, waLink, WHATSAPP_DISPLAY } from "@/lib/constants";

const EASE = [0.16, 1, 0.3, 1];

export const CtaBanner = () => (
  <section className="relative py-24 lg:py-36 overflow-hidden">
    <img
      src={IMAGES.banner}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-ink/85" />

    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: EASE }}
      className="relative z-10 px-4 sm:px-6 max-w-3xl mx-auto text-center"
    >
      <p className="inline-block font-mono text-[11px] uppercase tracking-[0.3em] text-volt border border-volt/40 px-4 py-2">
        ● Atendimento rápido pelo WhatsApp
      </p>
      <h2 className="mt-8 font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-7xl text-white">
        Está na hora de <span className="text-signal">cuidar do seu carro?</span>
      </h2>
      <p className="mt-6 text-sm sm:text-base text-gray-300 leading-relaxed max-w-xl mx-auto">
        Envie uma mensagem para nossa equipe e informe o modelo do seu veículo
        e o serviço que você precisa.
      </p>
      <a
        data-testid="cta-banner-whatsapp-button"
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-cut mt-10 inline-flex items-center gap-3 px-10 py-5 bg-signal hover:bg-signalhover text-white font-display font-bold uppercase tracking-wide text-xl transition-colors duration-300"
      >
        <MessageCircle className="h-6 w-6" />
        Falar com a MW Auto Center
      </a>
      <p className="mt-8 flex items-center justify-center gap-2 text-white">
        <Phone className="h-5 w-5 text-signal" />
        <span className="font-display font-bold text-2xl tracking-wide">{WHATSAPP_DISPLAY}</span>
      </p>
    </motion.div>
  </section>
);
